import { Question } from "../../../../../../scripts/gen-question/src/declare/question.model";

export const numberInputCheckRule = (
  question: Question,
  answerCache: any,
  inputValue: number
): string => {
  const questionCode = question.code;
  const v = (code: string) => {
    return answerCache[code].answer[0].value;
  };
  // B1103_2，根据 B1102 循环，循环的场地数量必须 等于 B1102 的数量
  if (questionCode.indexOf("B1103_") === 0) {
    try {
      // 1. 拒答，不作限制
      if (answerCache["B1101"].answer[0].code != "1") return "";
      const excpted = parseInt(v("B1101"));
      // 2. 获取循环
      const loopParent = answerCache["B1102"].answer;
      // 3. 判断循环的题是否都已回答
      const allFilled = loopParent.every((answer: any) => {
        const a = answerCache[`B1103_${answer.code}`];
        if (!a || !a.answer || !a.answer.length || !a.answer[0]) return false;
        const ans = a.answer[0];
        return ans.code == "1" && ans.value !== undefined;
      });
      const realSum = loopParent.reduce((sum: number, answer: any) => {
        const a = answerCache[`B1103_${answer.code}`];
        if (!a || !a.answer || !a.answer.length || !a.answer[0]) return sum;
        const ans = a.answer[0];
        return sum + (parseInt(ans.value) || 0);
      }, 0);

      if (allFilled) {
        if (realSum !== excpted) {
          return `场地数量总和（${realSum}）应等于 B1101 的答案 ( ${excpted} 个 )`;
        }
      } else {
        if (realSum > excpted) {
          return `场地数量总和（${realSum}）已超过  B1101 的答案 ( ${excpted} 个 )`;
        }
      }
    } catch (err) {
      console.log(err);
      return "";
    }
  }

  // B2107_ix, 根据 B2106 循环，最终的总和应该小于 100
  if (questionCode.indexOf("B2107_i") === 0) {
    try {
      const loopCount = parseInt(v("B2106")) || 0;
      let sum = 0;
      for (let i = 1; i <= loopCount; i++) {
        const a = answerCache[`B2107_i${i}`];
        if (!a || !a.answer || !a.answer.length || !a.answer[0]) continue;
        const ans = a.answer[0];
        sum += parseFloat(ans.value) || 0;
      }
      if (sum > 100) {
        return `所填写的占比总和为（${sum}%）已超过 100%`;
      }
    } catch (err) {
      console.log(err);
      return "";
    }
  }

  // B2217_ix, 答案必须小于 B2216_ix
  if (questionCode.indexOf("B2217_i") === 0) {
    try {
      // 1. 解析循环次数
      const loopSymbol = questionCode.replace(/B2217_i(.*)/, "$1");
      const value = parseFloat(v(`B2216_i${loopSymbol}`)) || Infinity;
      if (inputValue > value) {
        return `上一题显示，这笔贷款计划申请 ${value} 万元， 已超出`;
      }
    } catch (err) {
      console.log(err);
    }
  }

  // B4105 的 答案需要小于 B4104
  if (questionCode === "B4105") {
    try {
      const value = parseFloat(v("B4104")) || Infinity;
      if (inputValue > value) {
        return `上一题显示研发与创新的经费总支出为 ${value} 万元， 已超出`;
      }
    } catch (err) {}
  }

  // B4109b 的 答案要小于 B4109a
  if (questionCode === "B4109b") {
    try {
      const value = parseFloat(v("B4109a")) || Infinity;
      if (inputValue > value) {
        return `上一题显示共有发明专利 ${value} 件， 已超出`;
      }
    } catch (err) {}
  }

  // B4110b 的 答案要小于 B4110a
  if (questionCode === "B4110b") {
    try {
      const value = parseFloat(v("B4110a")) || Infinity;
      if (inputValue > value) {
        return `上一题显示共有实用新型专利 ${value} 件， 已超出`;
      }
    } catch (err) {}
  }

  // B4111b 的 答案要小于 B4111a
  if (questionCode === "B4111b") {
    try {
      const value = parseFloat(v("B4111a")) || Infinity;
      if (inputValue > value) {
        return `上一题显示共有外观设计专利 ${value} 件， 已超出`;
      }
    } catch (err) {}
  }

  // B5202 的 答案要小于 B5201
  if (questionCode === "B5202") {
    try {
      const value = parseFloat(v("B5201")) || Infinity;
      if (inputValue > value) {
        return `上一题显示共招聘了 ${value} 人， 已超出`;
      }
    } catch (err) {}
  }

  // D1016c4 的 答案要小于 D1016c1
  if (questionCode === "D1016c4") {
    try {
      const value = parseFloat(v("D1016c1")) || Infinity;
      if (inputValue > value) {
        return `D1016c1 显示共经营过 ${value} 个项目， 已超出`;
      }
    } catch (err) {}
  }

  // "D2009a", "D2009b", "D2009c", "D2009d" 之和不能超过 D2009 的答案
  // const d2009_relatived = ["D2009a", "D2009b", "D2009c", "D2009d"];
  // if (d2009_relatived.indexOf(questionCode) > -1) {
  //   try {
  //     const value = parseInt(v("D2009")) || Infinity;
  //     const sum = d2009_relatived.reduce((sum: number, code: string) => {
  //       const a = answerCache[code];
  //       if (!a || !a.answer || !a.answer.length || !a.answer[0]) return sum;
  //       return sum + (parseInt(a.answer[0].value) || 0);
  //     }, 0);
  //     if (sum > value) {
  //       return `D2009a ~ D2009d 的答案总和为 ${sum}, 已超出 D2009 的答案（${value}）`;
  //     }
  //   } catch (err) {}
  // }

  // "D2013a" + "D2013b" = "D2013"
  if (["D2013a", "D2013b"].indexOf(questionCode) > -1) {
    try {
      const value = parseInt(v("D2013")) || Infinity;
      const sum = ["D2013a", "D2013b"].reduce((sum: number, code: string) => {
        const a = answerCache[code];
        if (!a || !a.answer || !a.answer.length || !a.answer[0]) return sum;
        return sum + (parseInt(a.answer[0].value) || 0);
      }, 0);
      if (sum > value) {
        return `D2013a ~ D2013b 的答案总和为 ${sum}, 已超出 D2013 的答案（${value}）`;
      }
    } catch (err) {}
  }

  return "";
};
